export default __webpack_public_path__ + "static/media/gallery5.30c46d2a.jpg";